import type { GovTabsProps } from '@gov-design-system-ce/react';
import { GovTabs } from '@gov-design-system-ce/react';

export const Tabs = (props: GovTabsProps) => <GovTabs {...props} />;
